// extracted by mini-css-extract-plugin
module.exports = {"ShowcaseName":"ShowcaseName_ShowcaseName__3TWjH"};